import { UmbracoApiResponse } from 'src/types/umbracoApiResponse';
import { BoothContact, ProductHighlight, VendorBooth } from 'src/types/vendorBooth';
import { deleteUmbraco, getUmbraco, postUmbraco, postUmbracoFile } from './Api';

async function getBoothById(boothId: number): Promise<VendorBooth> {
  return getUmbraco<VendorBooth>(`/VendorPortalApi/GetBoothById?id=${boothId}`);
}

async function updateProperty(boothId: number, propertyName: string, propertyValue: string | number): Promise<boolean> {
  return postUmbraco<boolean>(`/VendorPortalApi/UpdateProperty?boothId=${boothId}`, {
    alias: propertyName,
    value: propertyValue,
  });
}

async function saveProductHighlights(boothId: number, productHighlights: ProductHighlight[]): Promise<boolean> {
  return postUmbraco<boolean>(`/VendorPortalApi/SaveProductHighlights?boothId=${boothId}`, productHighlights);
}

async function saveContacts(boothId: number, contacts: BoothContact[]): Promise<boolean> {
  return postUmbraco<boolean>(`/VendorPortalApi/SaveContacts?boothId=${boothId}`, contacts);
}

//For dropdown
async function getBoothsByVendor(vendorNumber: string | number): Promise<VendorBooth[]> {
  return getUmbraco<VendorBooth[]>(`/VendorPortalApi/GetBoothsByVendor?vendorNumber=${vendorNumber}`);
}

async function getLastYearsBooths(vendorNumber: string | number): Promise<VendorBooth[]> {
  return getUmbraco<VendorBooth[]>(`/VendorPortalApi/GetLastYearBoothsByVendor?vendorNumber=${vendorNumber}`);
}

async function uploadFile(file: File, boothId: number, imageFieldName: string): Promise<UmbracoApiResponse<string>> {
  const formData = new FormData();
  formData.append('file', file, file.name);

  return postUmbracoFile<UmbracoApiResponse<string>>(formData, '/VendorPortalApi/UploadFile?boothId=' + boothId + '&imageFieldName=' + imageFieldName);
}

//get image url from umb:// image udi
async function getImageUrlFromUdi(udi: string): Promise<UmbracoApiResponse<string>> {
  return getUmbraco<UmbracoApiResponse<string>>(`/VendorPortalApi/GetImageUrlFromUdi?udi=${udi}`);
}

async function createNewBooth(vendorNumber: string, vendorName: string): Promise<VendorBooth> {
  return postUmbraco<VendorBooth>(`/VendorPortalApi/CreateBoothForVendor?vendorNumber=${vendorNumber}&vendorName=${vendorName}`, {});
}

async function createNewBoothFromLastYear(vendorNumber: string, vendorName: string, boothId: number): Promise<VendorBooth> {
  return postUmbraco<VendorBooth>(`/VendorPortalApi/CreateNewBoothFromCopy?vendorNumber=${vendorNumber}&vendorName=${vendorName}&copyBoothId=${boothId}`, {});
}

async function deleteMediaByUdi(udi: string, alias: string, boothId: number): Promise<UmbracoApiResponse<any>> {
  return deleteUmbraco<UmbracoApiResponse<any>>(`/VendorPortalApi/DeleteMediaByUdi?udi=${encodeURIComponent(udi)}&alias=${alias}&boothId=${boothId}`);
}

export default {
  getBoothById,
  getBoothsByVendor,
  updateProperty,
  saveProductHighlights,
  saveContacts,
  uploadFile,
  getImageUrlFromUdi,
  createNewBooth,
  createNewBoothFromLastYear,
  deleteMediaByUdi,
  getLastYearsBooths
};
